<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="[]"
                      :permission="permission"
                      :searchs="searchs"
                      ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "CustomerService",
        components: {CommonTable},
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'status',
                    placeholder: '请选择状态',
                    type: 'select',
                    selectValue:[
                        {
                            key: "1",
                            value: "正常"
                        },
                        {
                            key: "0",
                            value: "锁定"
                        }
                    ]
                }],
                permission:{
                    add: 'customerService:add',
                    update: 'customerService:update',
                    delete: 'customerService:delete',
                    deleteBatch: 'customerService:deleteBatch'
                },
                url: {
                    get: '/customerService/listByCondition',
                    add: '/customerService/add',
                    update: '/customerService/update',
                    delete: '/customerService/delete/',
                    delete_batch: '/customerService/deleteBatch',
                    status: '/customerService/status'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '100',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    width: '',
                }, {
                    field: 'url',
                    label: '客服链接',
                    show: true,
                    width: ''
                },{
                    field: 'status',
                    label: '状态',
                    show: true,
                    detail: false,
                    width: '90',
                    status: true,
                }, {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '180px',
                }],
                formFields: {
                    addTitle: '添加用户',
                    updateTitle: '修改用户',
                    labelWidth: '80px',
                    model: [{
                        field: 'agentId',
                        label: '代理：',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'url',
                        label: '客服链接',
                        type: 'input',
                        placeholder: '客服链接',
                        rules: [{
                            message: '请输入客服链接', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
